/**
 * The one capability this app names by hand (ORDR-94).
 *
 * `access:grant` is paio-auth's `GRANT_CAPABILITY`
 * (`auth_service/access/grant_admin.py`), the capability that lets a holder
 * delegate at a scope. It is written out here rather than derived, for the same
 * reason `orderingPack.ts` declares its route table rather than building it
 * from the framework's constants: a value derived from the thing it is meant to
 * agree with asserts nothing, and would follow a rename silently.
 *
 * This is a RENDERING decision. The server checks the same capability
 * independently on every write, so a wrong value here costs a panel that does
 * not draw, never access that should not exist.
 */

export const GRANT_CAPABILITY = "access:grant";
